import { render, staticRenderFns } from "./Radar-write.vue?vue&type=template&id=084a3782&scoped=true&"
import script from "./Radar-write.vue?vue&type=script&lang=js&"
export * from "./Radar-write.vue?vue&type=script&lang=js&"
import style0 from "./Radar-write.vue?vue&type=style&index=0&id=084a3782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a3782",
  null
  
)

export default component.exports